import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { RestCallerService } from './rest-caller.service';

declare var $: any;
declare var ActiveXObject: any;
declare var swal: any;

@Injectable()
export class ImpExportService {

  exportFileName: string = "PYD.ZMP";

  constructor(private restCallingService: RestCallerService) {
  }

  doImpExport2(payerId: string, employeeIds: number[], payrollData: any) {
    this.restCallingService.getListofEmployees(employeeIds).subscribe((employeeData) => {
      var employeeList = employeeData.json();
      this.getUdfData(payerId, employeeList, payrollData);
    },
      err => {
        console.log(err.json());
        swal('Failure!', err.json().message,'error');
      });
  }

  getUdfData(payerId: string, employeeList: any, payrollData: any) {
    this.restCallingService.getClientUdfLookup(employeeList[0]["clientId"]).subscribe((resp) => {
      var udfData = $.map(resp.json()[0], function (val, ind) {
        if (val !== null && ind.indexOf('udf') > -1) {
          return val;
        }
      });
      //this.createImpFilev2(payerId, employeeList, payrollData, udfData);
      this.createImpFilev3(payerId, employeeList, payrollData, udfData);
    },
      err => {
        console.log(err.json());
        swal('Failure!', err.json().message,'error');
      }); 
  }

  createUdfString(record: any, udfData: any) {
    let totalUdfString = "";
    for (let i = 0; i < udfData.length; i++) {
      let udfName: string = udfData[i];
      let udfNum: string = "UDF" + (i + 1);
      let udfValue: any = record[udfNum.toLocaleLowerCase()];
      if (!udfName || !udfValue)
        continue;
      let udfString = udfNum + "=" + udfName + (i + 1) + "=" + udfValue + "\n";
      totalUdfString += udfString;
    }
    return totalUdfString;
  }

  createLocalString(record: any) {
    let localString: string = "";
    let localValue: string = record["localWithholding1"];
    if (localValue)
      localString = "LOCALWH=" + record["localWithholding1"] + '\n'; //only one LocalWH for the time being
    return localString;
  }

  createImpFilev2(payerId: string, employeeList: any, payrollData: any, udfData: any) {
    let data: String = "";
    for (var currentEmployee of employeeList) {
      payrollData.forEach((record) => {
        if (record['employeeId'] == currentEmployee['id']) {
          let row: string = "";
          row += ("SSN=" + this.getEmptyStringIfNull(currentEmployee['ssn']) + "\n")
            + ("CHECKDATE=" + this.formatNannyDate(record['payDate']) + "\n") // ALWAYS PRESENT
            + (currentEmployee['workState'] == null ? '' : ("STATE=" + currentEmployee['workState'] + "\n"))
            + ("GROSSPAY=" + this.getEmptyStringIfNull(record['grossPay']) + "\n") //ALWAYS PRESENT
            + (record['socialSecurityWithholding'] == null ? '' : ("FICAWH=" + record['socialSecurityWithholding'] + "\n"))
            + (record['medicareWithholding'] == null ? '' : ("MEDICARE=" + record['medicareWithholding'] + "\n"))
            + (record['federalWithholding'] == null ? '' : ("FITW=" + record['federalWithholding'] + "\n"))
            + (record['stateWithholding'] == null ? '' : ("STATEWH=" + record['stateWithholding'] + "\n"))
            + (record['cityWithholding'] == null ? '' : ("LOCALWH=" + record['cityWithholding'] + "\n"))
            + this.createUdfString(record, udfData)
            + this.createLocalString(record)
            + ("NETPAY=" + this.getEmptyStringIfNull(record['netPay']) + "\n") //ALWAYS PRESENT
            + "*\n";
          data += row;
        }
      });
    }
    data = data.slice(0, -1);
    this.tryDownloadToClientFolder(employeeList[0], data, payerId); //can pass any employee since theyre all belonging to the same payer
  }

  createImpFilev3(payerId: string, employeeList: any, payrollData: any, udfData: any) {
    let data: string = "";
    for (var currentEmployee of employeeList) {
      payrollData.forEach((record) => {
        if (record['employeeId'] == currentEmployee['id']) {
          let row: string = "";
          row += ("SSN=" + this.getEmptyStringIfNull(currentEmployee['ssn']) + "\n")
            + ("CHECKDATE=" + this.formatNannyDate(record['payDate']) + "\n") // ALWAYS PRESENT
            + (currentEmployee['workState'] == null ? '' : ("STATE=" + currentEmployee['workState'] + "\n"))
            + ("GROSSPAY=" + this.getEmptyStringIfNull(record['grossPay']) + "\n") //ALWAYS PRESENT
            + (record['socialSecurityWithholding'] == null ? '' : ("FICAWH=" + record['socialSecurityWithholding'] + "\n"))
            + (record['medicareWithholding'] == null ? '' : ("MEDICARE=" + record['medicareWithholding'] + "\n"))
            + (record['federalWithholding'] == null ? '' : ("FITW=" + record['federalWithholding'] + "\n"))
            + (record['stateWithholding'] == null ? '' : ("STATEWH=" + record['stateWithholding'] + "\n"))
            + (record['cityWithholding'] == null ? '' : ("LOCALWH=" + record['cityWithholding'] + "\n"))
            + this.createUdfString(record, udfData)
            + this.createLocalString(record)
            + ("NETPAY=" + this.getEmptyStringIfNull(record['netPay']) + "\n") //ALWAYS PRESENT
            + "*\n";
          data += row;
        }
      });
    }
    data = data.slice(0, -1);
    this.tryDownloadToClientFolderV2(employeeList[0], data, payerId); //can pass any employee since theyre all belonging to the same payer
  }

  getEmptyStringIfNull(property: string) {
    if (property) {
      return property;
    } else {
      return '';
    }
  }

  formatNannyDate(date: string) {
    let dateString: string;
    if (!date)
      dateString = ""
    else
      dateString = date.substring(5).replace("-", "/");
    return dateString;
  }

  tryDownloadToClientFolder(selectedEmployee: Object, data: String, payerId: string) {
    const configKeyValuePairs = JSON.parse(sessionStorage.getItem('currentUser'))['configKeyValuePairs'];
    let basefilepath: string = configKeyValuePairs['NANNYTAX_SHARE_FOLDER_BASE'];
    basefilepath = basefilepath.replace('//', '\\\\'); //replace initial double forward-slash with double black-slash
    var ua = window.navigator.userAgent;
    var trident = ua.indexOf('Trident/');
    if (trident < 0) {
      swal({ title: 'Direct Save Unavailable', text: 'Direct download to Payer folder is available only when using Internet Explorer, file will be downloaded locally.', icon: 'warning' }).then(()=>{
        this.restCallingService.downloadBlob(new Blob([data], { type: 'text/plain' }), this.exportFileName);
      });
      return;
    }
    var fso;
    try { fso = new ActiveXObject("Scripting.FileSystemObject"); } 
    catch (e) { console.log(e); }
    if (!fso || fso==null) {
      swal('Failure!', "Error initializing ActiveX, pelase make sure *.nannytax.com is added to your IE local intranet trusted sites",'error');
      return;
    }
    let filepath = basefilepath + payerId + '/' + this.exportFileName;
    var el = document.createElement("p");
    el.innerHTML='Do you want to save this ZMP file to ' + payerId + '\'s Payer folder? <br/><br/>'
    + '<i style="font-size: 12px">Path: '+filepath+'</i>';
    swal({
      title: 'Save Import file Directly?', content: el,
      icon: 'warning', buttons: ['No', 'Yes']
    }).then(
      (isConfirmed) => {
        if (isConfirmed) {
          try {
            var s = fso.CreateTextFile(filepath, true);
            s.WriteLine(data);
            s.Close();
            swal('Success!', this.exportFileName+' has been saved at ' + filepath, 'success').then(()=>{
              this.restCallingService.exportCurrentQuarter(selectedEmployee['id'], selectedEmployee['clientId']).subscribe(() => {
              }, err => {
                console.log(err.json());
                swal('Failure!', err.json().message,'error');
              });
            });
          }
          catch (e) {
            swal('Failure!',"Error: "+e.message, 'error');
          }
        } else { // Download locally if they decline the direct download
          this.restCallingService.downloadBlob(new Blob([data], { type: 'text/plain' }), this.exportFileName);
        }
      }
      );
  }

  tryDownloadToClientFolderV2(selectedEmployee: Object, data: string, payerId: string) {
    const configKeyValuePairs = JSON.parse(sessionStorage.getItem('currentUser'))['configKeyValuePairs'];
    let basefilepath: string = configKeyValuePairs['NANNYTAX_SHARE_FOLDER_BASE'];
    if(basefilepath.startsWith("//")) {
      basefilepath = basefilepath.replace('//',"");
    }
    basefilepath = basefilepath.replace('//', '\\\\'); //replace initial double forward-slash with double black-slash
    let filepath = basefilepath + payerId + '/' + this.exportFileName;
    var el = document.createElement("p");
    el.innerHTML = 'Do you want to save this ZMP file to ' + payerId + '\'s Payer folder? <br/><br/>'
      + '<i style="font-size: 12px">Path: ' + filepath + '</i>';
    swal({
      title: 'Save Import file Directly?', content: el,
      icon: 'warning', buttons: ['No', 'Yes']
    }).then(
      (isConfirmed) => {
        if (isConfirmed) {
          let encodedDataString = btoa(data);
          let encodedfilepath = btoa(filepath);
          let o: any = {};
          o['encodedDataString'] = encodedDataString
          o['encodedfilepath'] = encodedfilepath;
          this.restCallingService.exportPayroll(o).subscribe(data => {
            swal({
              title: "Success!",
              text: this.exportFileName + ' has been saved at ' + filepath,
              icon: "success"
            }).then(() => {
              this.restCallingService.exportCurrentQuarter(selectedEmployee['id'], selectedEmployee['clientId']).subscribe(() => {
              }, err => {
                console.log(err.json());
                swal('Failure!', err.json().message, 'error');
              });
            });
          });
        } else {
          this.restCallingService.downloadBlob(new Blob([data], { type: 'text/plain' }), this.exportFileName);
        }
      }
    )
  };
}


// WEBPACK FOOTER //
// ./src/app/common/services/imp-export.service.ts